import { Component, Injector, Input, OnDestroy, OnInit } from "@angular/core";
import { DatabaseIndexNameType } from "@shared/models/common/database-index-name.model";
import { BaseComponent } from "../base.component";

@Component({
  selector: "app-copy-to-clipboard",
  templateUrl: "./copy-to-clipboard.component.html",
  styleUrls: ["./copy-to-clipboard.component.scss"],
})
export class CopyToClipBoardComponent extends BaseComponent implements OnInit, OnDestroy {
    
    @Input() index: DatabaseIndexNameType;
    @Input() fileNumber: string;

  constructor(private injector: Injector) {
      super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
